// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 400px) {
    .chip-text {
      word-break: break-word;
      hyphens: auto;
      overflow-wrap: break-word;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Shared/Components/OptionChips/OptionChips.css"],"names":[],"mappings":"AAAA;IACI;MACE,sBAAsB;MACtB,aAAa;MACb,yBAAyB;IAC3B;EACF","sourcesContent":["@media (max-width: 400px) {\n    .chip-text {\n      word-break: break-word;\n      hyphens: auto;\n      overflow-wrap: break-word;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
